import { atomWithReset } from "jotai/utils";

export const buyerApprovalModalAtom = atomWithReset<{
  visible: boolean;
  viewOnly?: boolean;
  buyerId: string | null;
}>({
  visible: false,
  viewOnly: false,
  buyerId: null
});
